<template>
  <div class="footer">
    <div class="footer-content">
      <div
        class="footer-item"
        v-for="(item, index) in footerItems"
        :key="index"
      >
        <h3>{{ $t(item.title) }}</h3>
        <p
          @click="goAbout()"
          v-for="(paragraph, idx) in item.paragraphs"
          :key="idx"
        >
          {{ $t(paragraph) }}
        </p>
        <div v-if="item.qrCodes" class="footer-qcoder">
          <img
            v-for="(qrCode, qrIndex) in item.qrCodes"
            :key="qrIndex"
            :src="qrCode.src"
            :alt="qrCode.alt"
          />
        </div>
      </div>
    </div>
    <div class="filings">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        style="color: inherit; text-decoration: underline"
      >
        {{ filingsText }}
        <span
          v-for="(link, linkIndex) in filingsLinks"
          :key="linkIndex"
          class="filings_link"
        >
          {{ link.text }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      footerItems: [
        {
          title: "footer.aboutUs.title",
          paragraphs: ["footer.aboutUs.paragraphs.aboutHuiXin"],
        },
        {
          title: "footer.contactUs.title",
          paragraphs: [
            "footer.contactUs.paragraphs.address",
            "footer.contactUs.paragraphs.phone",
          ],
        },
        {
          title: "footer.followUs.title",
          qrCodes: [
            {
              src: require("@/assets/qcoder.jpg"),
              alt: "footer.followUs.qrCodes.alt1",
            },
            {
              src: require("@/assets/qcode.jpg"),
              alt: "footer.followUs.qrCodes.alt2",
            },
          ],
        },
      ],
      filingsText: " 惠信数据技术（广东）有限公司版权所有",
      filingsLinks: [{ text: "网站备案: 粤ICP备2025420018号" }],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        // 模拟从后端 API 获取数据
        // const response = await axios.get('/api/footer-data');
        // const data = response.data;
        // 更新组件数据
        // this.footerItems = data.footerItems;
        // this.filingsText = data.filingsText;
        // this.filingsLinks = data.filingsLinks;
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },
    goAbout() {
      this.$router.push("/About");
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  margin-top: 5vw; // 使用vw单位
  width: 100%;
  background-color: #333;

  .footer-content {
    display: flex;
    justify-content: space-between;
    max-width: 70vw; // 使用vw单位
    margin: 0 auto;
    padding-top: 4vw; // 转换为vw单位
  }

  .footer-item {
    flex: 1;
    padding: 0 5vw; // 使用vw单位代替固定像素值

    p {
      cursor: pointer;
    }
  }

  .footer-item h3 {
    margin-bottom: 0.8vw; // 转换为vw单位
    font-size: 1vw; // 使用vw单位，确保文本大小随视窗大小变化
    color: #fff;
  }

  .footer-item p {
    margin: 0.5vw 0;
    font-size: 0.8vw; // 使用vw单位
    color: #ccc;
  }

  .footer-item a {
    color: #ccc;
    text-decoration: none;
  }

  .footer-item a:hover {
    text-decoration: underline;
  }

  .footer-qcoder {
    display: flex;
    align-items: center;

    img {
      width: 4vw;
      height: 4vw;
      margin-right: 1vw;
    }
  }

  .filings {
    text-align: center;
    padding-top: 1vw;
    font-size: 0.7vw;
    color: #fff;
    a:hover {
      color: #1859b0;
    }
    span {
      color: #fff;
    }
  }
}

@media screen and (max-width: 940px) {
  .footer {
    margin-top: 5vw; // 使用vw单位
    width: 100%;
    background-color: #333;

    .footer-content {
      display: flex;
      justify-content: space-between;
      max-width: 70vw; // 使用vw单位
      margin: 0 auto;
      padding-top: 4vw; // 转换为vw单位
    }

    .footer-item {
      flex: 1;
      padding: 0 5vw; // 使用vw单位代替固定像素值

      p {
        cursor: pointer;
      }
    }

    .footer-item h3 {
      margin-bottom: 0.8vw; // 转换为vw单位
      font-size: 1.4vw; // 使用vw单位，确保文本大小随视窗大小变化
      color: #a0a0a0;
    }

    .footer-item p {
      margin: 0.5vw 0;
      font-size: 0.9vw; // 使用vw单位
      color: #ccc;
    }

    .footer-item a {
      color: #ccc;
      text-decoration: none;
    }

    .footer-item a:hover {
      text-decoration: underline;
    }

    .footer-qcoder {
      display: flex;
      align-items: center;

      img {
        width: 4vw;
        height: 4vw;
        margin-right: 1vw;
      }
    }

    .filings {
      text-align: center;
      padding-top: 0.2vw;
      font-size: 1vw;
      color: #fff;
      a:hover {
        color: #1859b0;
      }
      span {
        color: #fff;
      }
    }
  }
}
</style>